import { EllipsisOutlined } from '@ant-design/icons';
import { Dropdown } from 'antd';
import React from 'react';

type Props = {
  onActionClick: () => void;
};

export const BillsActionMenu = ({ onActionClick }: Props) => {
  return (
    <div className="actions-menu">
      <Dropdown
        menu={{
          items: [
            { key: 'download', label: 'Download', onClick: onActionClick },
          ],
        }}
        trigger={['click']}
      >
        <EllipsisOutlined rotate={90} />
      </Dropdown>
    </div>
  );
};
